"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initForgotPasswordPage = exports.showNewPasswordFields = void 0;
var hideLabel = function hideLabel() {
  var label = document.getElementById('VerificationCode_label');
  if (label) {
    label.style.display = 'none';
  }
};
var hideEmailParent = function hideEmailParent() {
  var email = document.getElementById('email');
  var parent = email === null || email === void 0 ? void 0 : email.parentElement;
  if (parent) {
    parent.style.display = 'none';
  }
};
var hideClaimsButton = function hideClaimsButton() {
  var claimsButton = document.getElementById('emailVerificationControl_but_change_claims');
  if (claimsButton) {
    claimsButton.style.display = 'none';
  }
};
var inlineSubmitButton = function inlineSubmitButton() {
  var submitButton = document.getElementById('continue');
  if (submitButton) {
    submitButton.style.display = 'inline';
  }
};
var relabelEmailCodeButton = function relabelEmailCodeButton() {
  var emailCodeButton = document.getElementById('emailVerificationControl_but_send_code');
  if (emailCodeButton) {
    emailCodeButton.textContent = 'Continue';
  }
};
var relabelVerifyCodeButton = function relabelVerifyCodeButton() {
  var verifyCodeButton = document.getElementById('emailVerificationControl_but_verify_code');
  if (verifyCodeButton) {
    verifyCodeButton.textContent = 'Continue';
  }
};
var modifySimpleModal = function modifySimpleModal() {
  var modalVerifyingBlurb = document.getElementById('verifying_blurb');
  if (modalVerifyingBlurb) {
    var messageSpan = document.createElement('span');
    messageSpan.setAttribute('class', 'q-inner-loading__message');
    messageSpan.textContent = 'Please wait while we process your information.';
    var circle = document.createElement('circle');
    circle.setAttribute('class', 'path');
    circle.setAttribute('cx', '50');
    circle.setAttribute('cy', '50');
    circle.setAttribute('r', '20');
    circle.setAttribute('fill', 'none');
    circle.setAttribute('stroke', 'currentColor');
    circle.setAttribute('stroke-width', '2');
    circle.setAttribute('stroke-miterlimit', '10');
    var spinner = document.createElement('svg');
    spinner.setAttribute('class', 'q-spinner q-spinner-mat q-spinner--hal q-spinner--orange');
    spinner.setAttribute('width', '56px');
    spinner.setAttribute('height', '56px');
    spinner.setAttribute('viewBox', '25 25 50 50');
    spinner.appendChild(circle);
    var messageBoxDiv = document.createElement('div');
    messageBoxDiv.setAttribute('class', 'q-inner-loading__message-box');
    messageBoxDiv.appendChild(spinner);
    messageBoxDiv.appendChild(messageSpan);
    modalVerifyingBlurb.replaceWith(messageBoxDiv);
  }
};
var showNewPasswordFields = function showNewPasswordFields(show) {
  var newPasswordFields = document.getElementsByClassName('Password');
  var _iterator = _createForOfIteratorHelper(newPasswordFields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var newPasswordField = _step.value;
      newPasswordField.style.display = show ? 'block' : 'none';
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
exports.showNewPasswordFields = showNewPasswordFields;
var initForgotPasswordPage = function initForgotPasswordPage() {
  var verificationMessage = document.getElementById('emailVerificationControl_success_message');
  if (verificationMessage) {
    verificationMessage.style.marginBottom = '30px';
    var verificationMessageObserver = new MutationObserver(function () {
      var _a;
      if (verificationMessage.style.display !== 'none') {
        verificationMessage.style.display = 'block';
        hideLabel();
        var textContent = (_a = verificationMessage.textContent) !== null && _a !== void 0 ? _a : '';
        if (textContent.includes('Verification code has been sent') || textContent.includes('verification code was sent')) {
          hideEmailParent();
        } else if (textContent.includes('The code has been verified')) {
          hideClaimsButton();
          inlineSubmitButton();
          var registrationForm = document.getElementById('attributeVerification');
          if (registrationForm) {
            (0, exports.showNewPasswordFields)(true);
          }
        }
      }
    });
    verificationMessageObserver.observe(verificationMessage, {
      attributes: true,
      childList: true
    });
  }
  relabelEmailCodeButton();
  relabelVerifyCodeButton();
  modifySimpleModal();
};
exports.initForgotPasswordPage = initForgotPasswordPage;
//# sourceMappingURL=forgotPassword.js.map